/**
 * Styles for the Display settings section.
 *
 * Section/group layout lives in SettingGroup.module.css — only the controls
 * unique to this section are here.
 */

.sliderContainer {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 180px;
}

.sliderValue {
  font-size: 13px;
  font-weight: 500;
  color: #d1d5db;
  min-width: 36px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
